module.exports = __webpack_public_path__ + "static/kovka4-39a5be4a7c5b60b61e2c0950ddb3ee08.png";